import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Node, NodeEntry } from '@alfresco/js-api';
import { filter, takeUntil } from 'rxjs/operators';

import { NodeInfoService } from '../../../services/node.service';

@Component({
  selector: 'app-tree-view-directory',
  templateUrl: './tree-view-directory.component.html',
  standalone: false,
})
export class TreeViewDirectoryComponent implements OnInit, OnDestroy {
  private readonly onDestroy$: Subject<boolean> = new Subject<boolean>();
  node: Node;
  clickedNodeName: string = null;

  constructor(private readonly nodeInfoService: NodeInfoService) {}

  /**
   * Subscription of Current Node
   * This will check if selected current node is a root folder of library?
   * If yes then assign its nodeId to show tree view of that node
   */
  ngOnInit() {
    this.nodeInfoService
      .getCurrentNode()
      .pipe(
        filter((nodeEntry) => Boolean(nodeEntry)),
        takeUntil(this.onDestroy$)
      )
      .subscribe((currentNode) => {
        this.node = currentNode.entry;
      });
  }

  /**
   * This method will be called on clicking any folder through tree view of library
   * This will navigate route to selected folder
   */
  onClick(node: NodeEntry): void {
    this.clickedNodeName = node.entry.name;
  }

  /**
   * This method will be called if any error occurs while showing tree view of library
   */
  onErrorOccurred(error) {
    this.clickedNodeName = '';
    console.warn(` --- handle error of browse tree --- ${error}`);
  }

  /**
   * Unsubscribe all the subscriptions on destory
   */
  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }
}
